import React from 'react';
import {store} from "../Redux/store"
import { Provider } from "react-redux";


export const  AppProvider = (ProvideComponents)=>{
    return (
    <Provider store={store}>
        {ProvideComponents.children}
    </Provider>
         );
   }


